var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-toggle" },
    [
      _c(
        "b-button",
        {
          class: { active: _vm.value === "list-view" },
          attrs: { variant: "primary", title: "List View" },
          on: {
            click: function ($event) {
              return _vm.toggleView("list-view")
            },
          },
        },
        [
          _c("img", {
            attrs: {
              src: require("../../assets/list_view.svg"),
              alt: "List View",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          class: { active: _vm.value === "grid-view" },
          attrs: { variant: "primary", title: "Grid View" },
          on: {
            click: function ($event) {
              return _vm.toggleView("grid-view")
            },
          },
        },
        [
          _c("img", {
            attrs: {
              src: require("../../assets/grid_view.svg"),
              alt: "Grid View",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }